<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Grupo: {{ categoriaDetalhes.nome }}
      </p>
    </div>
    <q-form @submit="criarSubGrupo">
      <div class="row col-12 q-col-gutter-sm q-mt-sm">
        <div
          class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Nome do Sub Grupo
          <q-input dense outlined v-model="subGrupo.nome" />
        </div>

        <div
          class="col-xs-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Descrição
          <q-input dense outlined v-model="subGrupo.descricao" />
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            dense
            class="q-mt-sm full-width"
            color="primary"
            label="Adicionar"
            type="submit"
            no-caps
            icon="add_circle_outline"
          />
        </div>
      </div>
    </q-form>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Sub Grupos Criados
        </span>
        <div
          class="row col-md-12 col-xs-12 justify-end text-brand-5 text-weight-bold q-mb-lg container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrarGrupo"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaSubGrupos"
        :loading="loading"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        hide-pagination
        flat
        row-key="uuid"
        hide-bottom
        :grid="$q.screen.lt.sm"
        v-model:pagination="pagination"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span v-if="!props.selected"> {{ props.row.nome }}</span>
              <q-input
                dense
                outlined
                v-else
                v-model="props.row.nome"
                style="width: 110px"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected"> {{ props.row.descricao }}</span>
              <q-input
                dense
                outlined
                v-else
                v-model="props.row.descricao"
                style="width: 140px"
              />
            </q-td>
            <q-td>
              <q-btn
                v-if="!props.selected"
                icon="edit"
                color="black"
                round
                flat
                @click="
                  (props.selected = !props.selected),
                    recebeDadosGrupo(props.row)
                "
              />
              <q-btn
                v-else
                icon="done"
                color="positive"
                round
                flat
                @click="editarGrupo(props.row)"
              />
            </q-td>
            <q-td>
              <q-btn
                icon="delete"
                color="red"
                round
                flat
                @click="deletarSubGrupo(props.row.uuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const router = useRouter();

    const uuid = route.params.uuid;
    const subGrupo = ref({ nome: "", descricao: "" });
    const unidadeId = route.params.unidadeId;
    const listaSubGrupos = ref([]);
    const selected = ref([]);
    const dados = ref({ nome: "", descricao: "" });
    let loading = ref(false);
    let disable = ref(false);
    const categoriaDetalhes = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });
    const filtrarGrupo = ref("");

    const detalharCategoria = async () => {
      try {
        const response = await store.dispatch("fer/detalharCategoria", {
          categoriaUuid: uuid,
        });
        categoriaDetalhes.value = response.data.result;
      } catch (error) {
        console.log(error);
      }
    };

    const listarSubGrupos = async (page = 1, rowsPerPage = 6) => {
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("fer/listarGrupos", {
          page: page,
          rowsPerPage: rowsPerPage,
          filtro: filtrarGrupo.value,
          categoria_uuid: uuid,
        });
        listaSubGrupos.value = response.resposta.result.data;
        pagination.value.rowsPerPage = response.resposta.result.per_page;
        pagination.value.page = response.resposta.result.current_page;
        pagination.value.rowsNumber = response.resposta.result.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const criarSubGrupo = async () => {
      if (subGrupo.value.nome == "") {
        quasar.notify({
          message: "Preencha o nome do Sub Grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (subGrupo.value.descricao == "") {
        quasar.notify({
          message: "Preencha a descrição do Sub Grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("fer/criarGrupo", {
          nome: subGrupo.value.nome,
          descricao: subGrupo.value.descricao,
          vendor_id: parseInt(unidadeId),
        });

        quasar.notify({
          message: "Sub Grupo Cadastrado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        let grupoUiid = response.data.result.uuid;
        vincularGrupo(grupoUiid);
        reset();
      } catch (error) {
        quasar.notify({
          message: "Erro ao cadastrar sub grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const vincularGrupo = async (grupoUiid) => {
      try {
        await store.dispatch("fer/vincularCategoriaAoGrupo", {
          categoria_uuid: uuid,
          grupo_uuid: grupoUiid,
        });
        listarSubGrupos();
      } catch (error) {
        console.log(error);
      }
    };

    const recebeDadosGrupo = (grupo) => {
      dados.value = {
        nome: grupo.nome,
        descricao: grupo.descricao,
      };
    };

    const editarGrupo = async (grupo) => {
      if (
        dados.value.nome == grupo.nome &&
        dados.value.descricao == grupo.descricao
      ) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("fer/editarGrupo", {
          nome: grupo.nome,
          descricao: grupo.descricao,
          uuid: grupo.uuid,
        });
        selected.value = [];
        listarSubGrupos();
        quasar.notify({
          message: "Sub Grupo criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar Sub Grupo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = async () => {
      subGrupo.value = {
        nome: "",
        descricao: "",
      };
    };

    const voltar = () => {
      router.push({ name: "cadastrarGrupo" });
    };

    const deletarSubGrupo = async (uuid) => {
      try {
        await store.dispatch("fer/deletarGrupo", {
          uuid: uuid,
        });
        quasar.notify({
          message: "Sub Grupo deletado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarSubGrupos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao deletar Sub Grupo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        listarSubGrupos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtrarGrupo.value,
      () => {
        listarSubGrupos();
      }
    );

    onMounted(() => {
      detalharCategoria();
      listarSubGrupos();
    });

    return {
      columns,
      detalharCategoria,
      uuid,
      subGrupo,
      vincularGrupo,
      reset,
      criarSubGrupo,
      unidadeId,
      listarSubGrupos,
      listaSubGrupos,
      selected,
      recebeDadosGrupo,
      dados,
      editarGrupo,
      loading,
      voltar,
      deletarSubGrupo,
      categoriaDetalhes,
      disable,
      pagination,
      filtrarGrupo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
</style>
